import { CalendarDayRegularIcon } from "@elixir/icons";
import { Appointment } from "@elixir/types";
import { ChipWithTooltip } from "ui";
import { getQueueTypeFromStatus } from "../../../../utils/appointment-utils";
import { QUEUE_TYPE } from "../../../../constants/appointments";
import { isClinicLevelApt } from "@elixir/utils/src/appointment-utils";
import useQueueStore from "../../../../stores/queue-store";

const RescheduleAppointment = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const setSelectedAppointment = useQueueStore(
    (state) => state.setSelectedAppointment
  );
  const setSelectSlotInfo = useQueueStore((state) => state.setSelectSlotInfo);
  const queueType = getQueueTypeFromStatus(apt.status);

  return queueType === QUEUE_TYPE.BOOKED ? (
    <ChipWithTooltip
      className={`${className} h-32 flex-1`}
      type={type}
      onClick={() => {
        setSelectedAppointment(apt);
        setSelectSlotInfo({
          aptChannel: "BOOKED",
          bookType: "RESCHEDULE",
          showModal: true,
        });
      }}
      icon={<CalendarDayRegularIcon className="dr-min-w-16 w-16" />}
      title="Reschedule"
      tooltipText="Reschedule Appointment"
    />
  ) : (
    <></>
  );
};

export default RescheduleAppointment;
